import React from "react";
import { url } from "../../api";
import type { ArtistArtwork } from "./types";
import { getArtistTheme } from "./themes";

interface Props {
  artwork: ArtistArtwork;
  onClick?: () => void;
}

// Picks the right theme component based on the artist's artistProfile.theme
// and renders the card. Themes own the entire card visual.
export const ArtistArtworkCard: React.FC<Props> = ({ artwork, onClick }) => {
  const ThemeComponent = getArtistTheme(artwork.artist?.theme);
  const pictureUrl = artwork.imageFilename
    ? `${url}/api/artists-gallery/images/${artwork.imageFilename}`
    : "";

  return <ThemeComponent artwork={artwork} pictureUrl={pictureUrl} onClick={onClick} />;
};

export default ArtistArtworkCard;
